/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../items/items';
import '../connect/v2/resources/error';
import '../connect/v2/catalog/resources/datatypes';
import '../connect/v2/inventory/resources/inventory';
import '../connect/v2/common/money';
import '../connect/v2/catalog/interfaces/search-catalog-items';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "items": {
        "nested": {
          "merchant": {
            "nested": {
              "CatalogObjectType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ITEM": 1,
                  "ITEM_IMAGE": 2,
                  "PAGE_TILE": 3,
                  "CATEGORY": 4,
                  "ITEM_VARIATION": 5,
                  "FEE": 6,
                  "PLACEHOLDER": 7,
                  "DISCOUNT": 8,
                  "ITEM_FEE_MEMBERSHIP": 9,
                  "ITEM_MODIFIER_LIST": 10,
                  "ITEM_ITEM_MODIFIER_LIST_MEMBERSHIP": 11,
                  "ITEM_MODIFIER_OPTION": 12,
                  "INVENTORY_INFO": 16,
                  "OBSOLETE_TENDER_FEE": 17,
                  "DINING_OPTION": 18,
                  "TAX_RULE": 19,
                  "CONFIGURATION": 20,
                  "PAGE": 21,
                  "TICKET_GROUP": 22,
                  "TICKET_TEMPLATE": 23,
                  "VOID_REASON": 24,
                  "ITEM_VARIATION_VENDOR_INFO": 25,
                  "MENU": 26,
                  "TAG": 27,
                  "FLOOR_PLAN": 28,
                  "FLOOR_PLAN_TILE": 29,
                  "FAVORITES_LIST_POSITION": 30,
                  "MENU_GROUP_MEMBERSHIP": 31,
                  "SURCHARGE": 32,
                  "PRICING_RULE": 33,
                  "PRODUCT_SET": 34,
                  "TIME_PERIOD": 35,
                  "SURCHARGE_FEE_MEMBERSHIP": 36,
                  "MEASUREMENT_UNIT": 37,
                  "SUBSCRIPTION_PLAN_VARIATION": 38,
                  "ITEM_OPTION": 39,
                  "ITEM_OPTION_VAL": 40,
                  "CUSTOM_ATTRIBUTE_DEFINITION": 41,
                  "CUSTOM_ATTRIBUTE_SELECTION": 42,
                  "QUICK_AMOUNTS_SETTINGS": 45,
                  "QUICK_AMOUNT": 46,
                  "COMPONENT": 47,
                  "COMPOSITION": 48,
                  "RESOURCE": 49,
                  "SUBSCRIPTION_PHASE": 50,
                  "CHECKOUT_LINK": 52,
                  "CHECKOUT_LINK_LINE_ITEM": 53,
                  "CHECKOUT_LINK_CUSTOM_FIELD": 54,
                  "SUBSCRIPTION_TAX_INFO": 55,
                  "EVENT": 56,
                  "ADDRESS": 57,
                  "CATALOG_CONFIGURATION": 58,
                  "SUBSCRIPTION_PLAN": 59,
                  "AVAILABILITY_PERIOD": 61,
                  "CREDIT_REDEMPTION_POLICY": 62,
                  "AGE_RESTRICTION": 63,
                  "COMBO_SLOT": 64,
                  "SALE_PRICE": 65,
                  "RECIPE": 66,
                  "INGREDIENT": 67,
                  "TAX_CATEGORY": 68,
                  "PRODUCT": 5,
                  "PRODUCT_FAMILY": 1,
                  "CATALOG": 100,
                  "CONSTRAINT": 101,
                  "ATTRIBUTE_DEFINITION_METADATA": 200
                }
              },
              "GetRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "query": {
                    "type": "squareup.items.merchant.Query",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "type": {
                    "type": "squareup.items.merchant.CatalogObjectType",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "modifiedAfter": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "enabledUnitTokens": {
                    "type": "string",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "includeDeleted": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "lockToken": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "initialVersionFallback": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "performSync": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "queryMatchAny": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "GetResponse": {
                "fields": {
                  "catalogObject": {
                    "type": "squareup.items.merchant.CatalogObject",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "attributeDefinition": {
                    "type": "squareup.items.merchant.AttributeDefinition",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "catalogVersion": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PutRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "catalogObject": {
                    "type": "squareup.items.merchant.CatalogObject",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "openTransaction": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "lockToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "lockDurationMs": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "ignoreCustomAttributePermissions": {
                    "type": "squareup.items.merchant.PutRequest.CustomAttributePermissionSetting",
                    "id": 8,
                    "rule": "optional"
                  },
                  "ignoreItemDefaults": {
                    "type": "squareup.items.merchant.PutRequest.IgnoreItemDefaultsField",
                    "id": 9,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "CustomAttributePermissionSetting": {
                    "values": {
                      "CUSTOM_ATTRIBUTE_PERMISSION_SETTING_DO_NOT_USE": 0,
                      "RESPECT_PERMISSION_SETTINGS": 1,
                      "IGNORE_PERMISSION_SETTINGS": 2
                    }
                  },
                  "IgnoreItemDefaultsField": {
                    "values": {
                      "IGNORE_ITEM_DEFAULTS_DO_NOT_USE": 0,
                      "IGNORE_ITEM_DEFAULTS_CHANNELS": 1
                    }
                  }
                }
              },
              "PutResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.items.merchant.PutResponse.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "catalogObject": {
                    "type": "squareup.items.merchant.CatalogObject",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "invalidCatalogObject": {
                    "type": "squareup.items.merchant.InvalidCatalogObject",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "modificationTimestamp": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "lockToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "attributeDefinition": {
                    "type": "squareup.items.merchant.AttributeDefinition",
                    "id": 6,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "SUCCESS": 1,
                      "ERROR": 2
                    }
                  }
                }
              },
              "AttributeDefinition": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.items.merchant.AttributeDefinition.Type",
                    "id": 3,
                    "rule": "optional"
                  },
                  "legacyScope": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "scope": {
                    "type": "squareup.items.merchant.AttributeDefinition.Scope",
                    "id": 25,
                    "rule": "optional"
                  },
                  "searchable": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "displayName": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "attributeClass": {
                    "type": "squareup.items.merchant.AttributeDefinition.AttributeClass",
                    "id": 27,
                    "rule": "optional"
                  },
                  "visibility": {
                    "type": "squareup.items.merchant.AttributeDefinition.AttributeVisibility",
                    "id": 24,
                    "rule": "optional"
                  },
                  "key": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "applicationId": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "TYPE_DO_NOT_USE": 0,
                      "STRING": 1,
                      "INT": 2,
                      "BOOLEAN": 3,
                      "TOKEN": 4,
                      "ENUM": 5,
                      "TEXT": 6,
                      "FOREIGN_TOKEN": 7,
                      "DECIMAL": 9,
                      "SELECTION": 10,
                      "STRING_INT": 11,
                      "TOKEN_INT": 12
                    }
                  },
                  "Scope": {
                    "values": {
                      "SCOPE_DO_NOT_USE": 0,
                      "SQUARE": 1,
                      "MERCHANT": 2,
                      "APPLICATION": 3
                    }
                  },
                  "AttributeClass": {
                    "values": {
                      "ATTRIBUTE_CLASS_DO_NOT_USE": 0,
                      "INTERNAL": 1,
                      "CUSTOM": 2
                    }
                  },
                  "AttributeVisibility": {
                    "fields": {
                      "objectTypes": {
                        "type": "squareup.items.merchant.CatalogObjectType",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "DeleteRequest": {
                "fields": {
                  "catalogObjectToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "openTransaction": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "lockToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "lockDurationMs": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "skipRollback": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "DeleteResponse": {
                "fields": {
                  "count": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "modificationTimestamp": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deletedObjects": {
                    "type": "squareup.items.merchant.DeleteResponse.DeletedObject",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "lockToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeletedObject": {
                    "fields": {
                      "type": {
                        "type": "squareup.items.merchant.CatalogObjectType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "token": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "CatalogObject": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.items.merchant.CatalogObjectType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "attribute": {
                    "type": "squareup.items.merchant.Attribute",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "version": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "cogsId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "deleted": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "InvalidCatalogObject": {
                "fields": {
                  "catalogObject": {
                    "type": "squareup.items.merchant.CatalogObject",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "squareup.items.merchant.InvalidCatalogObject.Reason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "data": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "message": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Reason": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "VERSION_MISMATCH": 1,
                      "ATTRIBUTE_TYPE_MISMATCH": 3,
                      "ATTRIBUTE_NOT_UNIQUE": 4,
                      "ATTRIBUTE_VALUE_OVER_LIMIT": 5,
                      "ATTRIBUTE_DEFINITION_TOKEN_UNKNOWN": 6,
                      "OBJECT_NONEXISTENT": 7,
                      "ATTRIBUTE_NONEXISTENT": 8,
                      "V1_OBJECT_VALIDATION_FAILED": 9,
                      "DUPLICATE_TEMPORARY_OBJECT_TOKEN": 10,
                      "REQUIRED_ATTRIBUTE_MISSING": 11,
                      "BROKEN_OBJECT_REFERENCE": 12,
                      "ATTRIBUTE_VALUE_UNDER_LIMIT": 13,
                      "NULL_ATTRIBUTE": 14,
                      "INVALID_OBJECT_TYPE": 15,
                      "INVALID_UNIT": 16,
                      "OBJECT_DELETED": 17,
                      "ATTRIBUTE_IMMUTABLE": 18,
                      "DUPLICATE_ATTRIBUTE": 19,
                      "DUPLICATE_OBJECT": 20,
                      "BROKEN_MEMBERSHIP": 21,
                      "ILLEGAL_UNIT_OVERRIDE": 22,
                      "OBJECT_ENABLED_AT_MULTIPLE_UNITS": 23,
                      "FORBIDDEN_ATTRIBUTE": 24,
                      "OBJECT_DISABLED": 25,
                      "GIFT_CARD_ONE_VARIATION": 26,
                      "UNKNOWN_UNIT": 27,
                      "TOO_MANY_ATTRIBUTES": 28,
                      "INVALID_STRING": 29,
                      "WRONG_OBJECT_TYPE": 30,
                      "INVALID_CURRENCY": 31,
                      "ATTRIBUTE_UNIT_OVERRIDE_ONLY": 32,
                      "UNEXPECTED_ATTRIBUTE_FOUND": 33,
                      "ITEM_OPTION_NOT_UNIQUE": 34,
                      "UNKNOWN_ITEM_OPTION_VAL": 35,
                      "PRODUCT_SET_FORMS_CYCLIC_LINK": 36,
                      "INT_COMPARISON_FAILED": 38,
                      "TOO_MANY_REFERENCES": 39,
                      "TOO_MANY_OBJECTS_OF_TYPE": 40,
                      "ITEM_OPTION_VAL_NOT_FOUND": 41,
                      "INVALID_UTF8": 42,
                      "VARIATION_ITEM_OPTIONS_MISMATCH": 43,
                      "VARIATION_ITEM_OPTION_VALUE_MISMATCH": 44,
                      "FIXED_DISCOUNT_ONLY_FOR_PRICING_RULE": 45,
                      "REQUIRED_SHARED_ATTRIBUTE_MISMATCH": 46,
                      "SUBSCRIPTION_PLAN_PHASES_INVALID": 47,
                      "INVALID_FIELD_VALUE": 49,
                      "SUBSCRIPTION_PHASE_REQUIRES_PERIOD": 51,
                      "INVALID_COLOR_CODE": 53,
                      "COUNTRY_SPECIFIC_FEATURE_USED": 54,
                      "UNKNOWN_SELECTION_TOKEN": 55,
                      "INVALID_URL": 56,
                      "TAX_PRODUCT_SET_CANNOT_HAVE_QUANTITY_EXACT_NOR_MAX": 57,
                      "TAX_CANNOT_ASSOCIATE_WITH_BOTH_IFM_AND_PRODUCT_SET": 58,
                      "CUSTOM_TYPE_SURCHARGE_ONLY_FOR_PRICING_RULE": 59,
                      "STACKABLE_PRICING_RULE_MUST_BE_ATTACHED": 60,
                      "CATEGORY_MAX_DEPTH_EXCEEDED": 61,
                      "OBJECTS_ENABLED_AT_DIFFERENT_LOCATIONS": 62,
                      "INVALID_TAX_PRODUCT_SET": 63,
                      "INVALID_REPORTING_CATEGORY": 64,
                      "OBJECT_FORMS_CYCLIC_LINK": 65,
                      "INVALID_WEIGHT_UNIT_FOR_COUNTRY": 66,
                      "PRODUCT_TYPE_INELIGIBLE_FOR_STOCK_TRACKING": 67,
                      "PRICING_RULE_FOR_CUSTOM_SURCHARGE_MUST_BE_FIXED_PERCENTAGE": 68,
                      "INVALID_SURCHARGE_TARGET_SCOPE_BASED_ON_TREATMENT_TYPE": 69,
                      "PRICING_RULE_FOR_CUSTOM_SURCHARGE_MUST_BE_EXCLUSIVE": 70,
                      "PRICING_RULE_FOR_CUSTOM_SURCHARGE_REQUIRE_TIME_PERIOD": 71,
                      "INVALID_PRODUCT_TYPE_MODIFICATION": 72,
                      "INVALID_CANADIAN_FREE_TEXT_DONATION_CATEGORY": 101,
                      "UNDEFINED_ERROR": 100
                    }
                  }
                }
              },
              "Attribute": {
                "fields": {
                  "definitionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "intValue": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "stringValue": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CogsId": {
                "fields": {
                  "objectId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Query": {
                "fields": {
                  "type": {
                    "type": "squareup.items.merchant.Query.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "key": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "neighborTypes": {
                    "type": "squareup.items.merchant.Query.NeighborType",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "setQueryValues": {
                    "type": "string",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "excludeRootObjects": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "additionalKeys": {
                    "type": "string",
                    "id": 13,
                    "rule": "repeated"
                  },
                  "textTerm": {
                    "type": "string",
                    "id": 2
                  },
                  "range": {
                    "type": "squareup.items.merchant.Query.Range",
                    "id": 3
                  },
                  "cogsId": {
                    "type": "squareup.items.merchant.CogsId",
                    "id": 5
                  },
                  "sortedAttribute": {
                    "type": "squareup.items.merchant.Query.SortedAttribute",
                    "id": 7
                  },
                  "attributeValues": {
                    "type": "squareup.items.merchant.Query.AttributeValues",
                    "id": 9
                  },
                  "sortedStringIntAttribute": {
                    "type": "squareup.items.merchant.Query.SortedStringIntAttribute",
                    "id": 14
                  },
                  "versionedObjects": {
                    "type": "squareup.items.merchant.Query.VersionedObjects",
                    "id": 15
                  },
                  "booleanAttribute": {
                    "type": "squareup.items.merchant.Query.BooleanAttribute",
                    "id": 16
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PREFIX": 1,
                      "EXACT": 2,
                      "RANGE": 3,
                      "TOKEN": 4,
                      "TEXT": 5,
                      "LEGACY_ID": 6,
                      "NEIGHBOR": 7,
                      "SORTED_ATTRIBUTE": 8,
                      "SET": 9,
                      "ATTRIBUTE_VALUES": 10,
                      "PRICING_OBJECTS_FOR_PRODUCTS": 13,
                      "SORTED_STRING_INT_ATTRIBUTE": 15,
                      "DOES_NOT_EXIST": 16,
                      "VERSIONED_OBJECTS": 17,
                      "BOOLEAN": 18
                    }
                  },
                  "Range": {
                    "fields": {
                      "begin": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "end": {
                        "type": "int64",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "BooleanAttribute": {
                    "fields": {
                      "value": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "SortedAttribute": {
                    "fields": {
                      "initialAttributeValue": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sortOrder": {
                        "type": "squareup.items.merchant.Query.SortedAttribute.SortOrder",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "ASCENDING"
                        }
                      },
                      "includeObjectsMissingAttribute": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    },
                    "nested": {
                      "SortOrder": {
                        "values": {
                          "ASCENDING": 1,
                          "DESCENDING": 2
                        }
                      }
                    }
                  },
                  "SortedStringIntAttribute": {
                    "fields": {
                      "attributeValue": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sortOrder": {
                        "type": "squareup.items.merchant.Query.SortedStringIntAttribute.SortOrder",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "ASCENDING"
                        }
                      },
                      "initialIntValue": {
                        "type": "int64",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "SortOrder": {
                        "values": {
                          "ASCENDING": 1,
                          "DESCENDING": 2
                        }
                      }
                    }
                  },
                  "AttributeValues": {
                    "fields": {
                      "attributeValues": {
                        "type": "squareup.items.merchant.Query.AttributeValues.AttributeValue",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "AttributeValue": {
                        "fields": {
                          "attributeDefinitionTokens": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "intValue": {
                            "type": "int64",
                            "id": 2
                          },
                          "stringValue": {
                            "type": "string",
                            "id": 3
                          }
                        },
                        "nested": {
                          "value": {
                            "oneof": ["intValue", "stringValue"]
                          }
                        }
                      }
                    }
                  },
                  "NeighborType": {
                    "fields": {
                      "objectType": {
                        "type": "squareup.items.merchant.CatalogObjectType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "attributeDefinitionTokens": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "VersionedObjects": {
                    "fields": {
                      "version": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "tokens": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "term": {
                    "oneof": ["textTerm", "range", "cogsId", "sortedAttribute", "attributeValues", "sortedStringIntAttribute", "versionedObjects", "booleanAttribute"]
                  }
                }
              },
              "RstMenusMigrationOptInRequest": {
                "fields": {}
              },
              "RstMenusMigrationOptInResponse": {
                "fields": {
                  "statusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "StockLevel": {
                "values": {
                  "INVALID": 0,
                  "OUT": 1,
                  "LOW": 2
                }
              },
              "SearchCatalogRequest": {
                "fields": {
                  "textFilter": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "categoryToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "stockLevel": {
                    "type": "squareup.items.merchant.StockLevel",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "enabledUnitTokens": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "vendorToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 7,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": "squareup.items.merchant.SearchCatalogRequest.SortOrder",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": "ASC"
                    }
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "productType": {
                    "type": "squareup.api.items.Item.Type",
                    "id": 10,
                    "rule": "optional",
                    "options": {
                      "default": "REGULAR"
                    }
                  },
                  "productTypes": {
                    "type": "squareup.api.items.Item.Type",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "doesNotExist": {
                    "type": "squareup.items.merchant.SearchCatalogRequest.NullableField",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "searchVendorCode": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "customAttributeFilters": {
                    "type": "squareup.items.merchant.CustomAttributeFilter",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "soldOut": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  },
                  "useAltSortName": {
                    "type": "bool",
                    "id": 19,
                    "rule": "optional"
                  },
                  "includeObjects": {
                    "type": "squareup.items.merchant.CatalogObjectType",
                    "id": 20,
                    "rule": "repeated"
                  },
                  "trackInventoryUnitTokens": {
                    "type": "string",
                    "id": 21,
                    "rule": "repeated"
                  },
                  "includeInventoryCounts": {
                    "type": "bool",
                    "id": 22,
                    "rule": "optional"
                  },
                  "textSearchFilter": {
                    "type": "squareup.items.merchant.SearchCatalogRequest.MultiFieldTextFilter",
                    "id": 24,
                    "rule": "repeated"
                  },
                  "sort": {
                    "type": "squareup.items.merchant.SearchCatalogRequest.Sort",
                    "id": 25,
                    "rule": "optional"
                  },
                  "includeRelatedObjects": {
                    "type": "squareup.items.merchant.CatalogObjectType",
                    "id": 26,
                    "rule": "repeated"
                  },
                  "includeTotalHits": {
                    "type": "bool",
                    "id": 27,
                    "rule": "optional"
                  },
                  "ecomVisibilities": {
                    "type": "squareup.api.items.Item.EcomVisibility",
                    "id": 28,
                    "rule": "repeated"
                  },
                  "excludeProductTypes": {
                    "type": "squareup.api.items.Item.Type",
                    "id": 29,
                    "rule": "repeated"
                  },
                  "inventoryCountsUnitTokenFilter": {
                    "type": "string",
                    "id": 30,
                    "rule": "repeated"
                  },
                  "archivedState": {
                    "type": "squareup.items.merchant.SearchCatalogRequest.ArchivedState",
                    "id": 31,
                    "rule": "optional",
                    "options": {
                      "default": "ARCHIVED_STATE_NOT_ARCHIVED"
                    }
                  },
                  "channels": {
                    "type": "string",
                    "id": 32,
                    "rule": "repeated"
                  },
                  "hasSalePrice": {
                    "type": "bool",
                    "id": 33,
                    "rule": "optional"
                  },
                  "stockQuantity": {
                    "type": "squareup.items.merchant.Range",
                    "id": 34,
                    "rule": "optional"
                  },
                  "itemIds": {
                    "type": "string",
                    "id": 35,
                    "rule": "repeated"
                  },
                  "excludeItemIds": {
                    "type": "string",
                    "id": 36,
                    "rule": "repeated"
                  },
                  "cardinalityAggregations": {
                    "type": "squareup.items.merchant.CardinalityAggregation",
                    "id": 37,
                    "rule": "repeated"
                  },
                  "sellable": {
                    "type": "squareup.items.merchant.SearchCatalogRequest.SellableValue",
                    "id": 38,
                    "rule": "optional"
                  },
                  "stockable": {
                    "type": "squareup.items.merchant.SearchCatalogRequest.StockableValue",
                    "id": 39,
                    "rule": "optional"
                  },
                  "enabledFulfillmentMethods": {
                    "type": "squareup.items.merchant.SearchCatalogRequest.EnabledFulfillmentMethodsFilter",
                    "id": 40,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Sort": {
                    "fields": {
                      "field": {
                        "type": "squareup.items.merchant.SearchCatalogRequest.Sort.SortField",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": "ITEM_NAME"
                        }
                      },
                      "order": {
                        "type": "squareup.items.merchant.SearchCatalogRequest.Sort.SortOrder",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "ASC"
                        }
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "SortField": {
                        "values": {
                          "SORT_FIELD_DO_NOT_USE": 0,
                          "ITEM_NAME": 1,
                          "ITEM_VARIATION_INVENTORY_COUNT": 2
                        }
                      },
                      "SortOrder": {
                        "values": {
                          "SORT_ORDER_DO_NOT_USE": 0,
                          "ASC": 1,
                          "DESC": 2
                        }
                      }
                    }
                  },
                  "SortOrder": {
                    "values": {
                      "ASC": 1,
                      "DESC": 2
                    }
                  },
                  "NullableField": {
                    "values": {
                      "VENDOR_TOKEN": 1,
                      "SKU": 2,
                      "CATEGORY_TOKEN": 3,
                      "REGULAR_CATEGORY_TOKEN": 4,
                      "FULFILLMENT_METHODS": 5
                    }
                  },
                  "ArchivedState": {
                    "values": {
                      "ARCHIVED_STATE_DO_NOT_USE": 0,
                      "ARCHIVED_STATE_NOT_ARCHIVED": 1,
                      "ARCHIVED_STATE_ARCHIVED": 2,
                      "ARCHIVED_STATE_ALL": 3
                    }
                  },
                  "MultiFieldTextFilter": {
                    "fields": {
                      "textFilter": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fields": {
                        "type": "squareup.items.merchant.SearchCatalogRequest.MultiFieldTextFilter.FieldValues",
                        "id": 2,
                        "rule": "optional"
                      },
                      "matchWholePhrase": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "enableFuzzySearch": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "SearchField": {
                        "values": {
                          "ITEM_NAME": 1,
                          "ITEM_DESCRIPTION": 2,
                          "ITEM_ABBREVIATION": 3,
                          "ITEM_VARIATION_NAME": 4,
                          "ITEM_VARIATION_SKU": 5,
                          "ITEM_VARIATION_UPC": 6,
                          "ITEM_VARIATION_VENDOR_CODE": 7,
                          "ITEM_CUSTOM_ATTRIBUTES_STRING": 8,
                          "ITEM_VARIATION_CUSTOM_ATTRIBUTES_STRING": 9,
                          "ITEM_CUSTOM_ATTRIBUTES_NUMBER": 10,
                          "ITEM_VARIATION_CUSTOM_ATTRIBUTES_NUMBER": 11,
                          "ITEM_CUSTOM_ATTRIBUTES_SELECTION": 12,
                          "ITEM_VARIATION_CUSTOM_ATTRIBUTES_SELECTION": 13
                        }
                      },
                      "FieldValues": {
                        "fields": {
                          "any": {
                            "type": "squareup.items.merchant.SearchCatalogRequest.MultiFieldTextFilter.SearchField",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "all": {
                            "type": "squareup.items.merchant.SearchCatalogRequest.MultiFieldTextFilter.SearchField",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "none": {
                            "type": "squareup.items.merchant.SearchCatalogRequest.MultiFieldTextFilter.SearchField",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  },
                  "SellableValue": {
                    "values": {
                      "SELLABLE_VALUE_DO_NOT_USE": 0,
                      "SELLABLE": 1,
                      "NON_SELLABLE": 2
                    }
                  },
                  "StockableValue": {
                    "values": {
                      "STOCKABLE_VALUE_DO_NOT_USE": 0,
                      "STOCKABLE": 1,
                      "NON_STOCKABLE": 2
                    }
                  },
                  "EnabledFulfillmentMethodsFilter": {
                    "fields": {
                      "enabledFulfillmentMethods": {
                        "type": "squareup.items.merchant.EnabledFulfillmentMethod",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "filterType": {
                        "type": "squareup.items.merchant.FilterType",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "MATCH_ALL"
                        }
                      }
                    }
                  }
                }
              },
              "EnabledFulfillmentMethod": {
                "values": {
                  "ENABLED_FULFILLMENT_METHOD_DO_NOT_USE": 0,
                  "PICKUP": 1,
                  "DELIVERY": 2,
                  "DINE_IN": 3,
                  "SHIPPING": 4
                }
              },
              "FilterType": {
                "values": {
                  "FILTER_TYPE_DO_NOT_USE": 0,
                  "MATCH_ALL": 1,
                  "MATCH_ANY": 2
                }
              },
              "Range": {
                "fields": {
                  "min": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "max": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CardinalityAggregation": {
                "fields": {
                  "field": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "precisionThreshold": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CustomAttributeFilter": {
                "fields": {
                  "customAttributeDefinitionToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "stringFilter": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "numberFilter": {
                    "type": "squareup.items.merchant.Range",
                    "id": 4,
                    "rule": "optional"
                  },
                  "selectionTokensFilter": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "boolFilter": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "existsFilter": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "SkuCatalogBackfillRequest": {
                "fields": {
                  "variationTokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "SkuCatalogBackfillResponse": {
                "fields": {
                  "statusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateInventoryTrackingRequest": {
                "fields": {}
              },
              "UpdateInventoryTrackingResponse": {
                "fields": {
                  "statusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "VariationTokenList": {
                "fields": {
                  "variationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "DashboardSearchCatalogResponse": {
                "fields": {
                  "catalogObject": {
                    "type": "squareup.items.merchant.CatalogObject",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "matchedVariations": {
                    "type": "squareup.items.merchant.VariationTokenList",
                    "id": 3,
                    "keyType": "string"
                  }
                }
              },
              "MembershipUpdateRequest": {
                "fields": {
                  "membershipType": {
                    "type": "squareup.items.merchant.CatalogObjectType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "targetObjectToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "selectAll": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "exceptionItemTokens": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "taxOptions": {
                    "type": "squareup.items.merchant.MembershipUpdateTaxOptions",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "MembershipUpdateTaxOptions": {
                "fields": {
                  "createMatchAllProductSet": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MembershipUpdateResponse": {
                "fields": {
                  "statusToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SearchCatalogItemsDashboardResponse": {
                "fields": {
                  "errors": {
                    "type": "squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "items": {
                    "type": "squareup.items.merchant.CatalogItemWrapper",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cursor": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CatalogItemWrapper": {
                "fields": {
                  "item": {
                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                    "id": 1,
                    "rule": "optional"
                  },
                  "additionalItemData": {
                    "type": "squareup.items.merchant.AdditionalItemData",
                    "id": 2,
                    "rule": "optional"
                  },
                  "additionalItemVariationData": {
                    "type": "squareup.items.merchant.AdditionalItemVariationData",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "matchedVariationIds": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "AdditionalItemData": {
                "fields": {
                  "categoryName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "images": {
                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "AdditionalItemVariationData": {
                "fields": {
                  "variationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "inventoryCounts": {
                    "type": "squareup.connect.v2.inventory.resources.InventoryCount",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "vendorInfos": {
                    "type": "squareup.items.merchant.VariationVendorInfo",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "composition": {
                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                    "id": 4,
                    "rule": "optional"
                  },
                  "images": {
                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "stockableConversion": {
                    "type": "squareup.connect.v2.merchant_catalog.resources.CatalogStockConversion",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "VariationVendorInfo": {
                "fields": {
                  "vendorToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cost": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "vendorCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "ordinal": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ReorderObjectRequest": {
                "fields": {
                  "objectToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "parentObjectToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "afterObjectToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "moveTo": {
                    "type": "squareup.items.merchant.ReorderObjectRequest.MoveTo",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MoveTo": {
                    "values": {
                      "MOVE_TO_DO_NOT_USE": 0,
                      "TOP": 1,
                      "BOTTOM": 2
                    }
                  }
                }
              },
              "BatchReorderObjectsRequest": {
                "fields": {
                  "idempotencyKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "requests": {
                    "type": "squareup.items.merchant.ReorderObjectRequest",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "BatchReorderObjectsResponse": {
                "fields": {
                  "catalogObjects": {
                    "type": "squareup.items.merchant.CatalogObject",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "Feature": {
                "values": {
                  "FEATURE_DO_NOT_USE": 0,
                  "FEATURE_ADVANCED_CATEGORIES_BETA": 1
                }
              },
              "AddMerchantToFeatureRequest": {
                "fields": {
                  "feature": {
                    "type": "squareup.items.merchant.Feature",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AddMerchantToFeatureResponse": {
                "fields": {}
              },
              "GenerateSkuValuesInventoryRequest": {
                "fields": {
                  "count": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GenerateSkuValuesInventoryResponse": {
                "fields": {
                  "skus": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "MerchantCatalogApiDashboardFe": {
                "methods": {
                  "Get": {
                    "requestType": "squareup.items.merchant.GetRequest",
                    "responseType": "squareup.items.merchant.GetResponse"
                  },
                  "Put": {
                    "requestType": "squareup.items.merchant.PutRequest",
                    "responseType": "squareup.items.merchant.PutResponse"
                  },
                  "Delete": {
                    "requestType": "squareup.items.merchant.DeleteRequest",
                    "responseType": "squareup.items.merchant.DeleteResponse"
                  },
                  "SearchCatalog": {
                    "requestType": "squareup.items.merchant.SearchCatalogRequest",
                    "responseType": "squareup.items.merchant.DashboardSearchCatalogResponse"
                  },
                  "SearchCatalogItemsDashboard": {
                    "requestType": "squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest",
                    "responseType": "squareup.items.merchant.SearchCatalogItemsDashboardResponse"
                  },
                  "BatchReorderObjects": {
                    "requestType": "squareup.items.merchant.BatchReorderObjectsRequest",
                    "responseType": "squareup.items.merchant.BatchReorderObjectsResponse"
                  },
                  "AddMerchantToFeature": {
                    "requestType": "squareup.items.merchant.AddMerchantToFeatureRequest",
                    "responseType": "squareup.items.merchant.AddMerchantToFeatureResponse"
                  },
                  "RstMenusMigrationOptIn": {
                    "requestType": "squareup.items.merchant.RstMenusMigrationOptInRequest",
                    "responseType": "squareup.items.merchant.RstMenusMigrationOptInResponse"
                  },
                  "GenerateSkuValues": {
                    "requestType": "squareup.items.merchant.GenerateSkuValuesInventoryRequest",
                    "responseType": "squareup.items.merchant.GenerateSkuValuesInventoryResponse"
                  }
                }
              },
              "MerchantCatalogApiDashboardFeBulk": {
                "methods": {
                  "MembershipUpdateStart": {
                    "requestType": "squareup.items.merchant.MembershipUpdateRequest",
                    "responseType": "squareup.items.merchant.MembershipUpdateResponse"
                  },
                  "SkuCatalogBackfillStart": {
                    "requestType": "squareup.items.merchant.SkuCatalogBackfillRequest",
                    "responseType": "squareup.items.merchant.SkuCatalogBackfillResponse"
                  },
                  "UpdateInventoryTrackingStart": {
                    "requestType": "squareup.items.merchant.UpdateInventoryTrackingRequest",
                    "responseType": "squareup.items.merchant.UpdateInventoryTrackingResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.CatalogObjectType && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.GetRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.GetResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.PutRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.PutRequest?.nested?.CustomAttributePermissionSetting && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.PutRequest?.nested?.IgnoreItemDefaultsField && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.PutResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.PutResponse?.nested?.Status && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AttributeDefinition && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AttributeDefinition?.nested?.Type && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AttributeDefinition?.nested?.Scope && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AttributeDefinition?.nested?.AttributeClass && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AttributeDefinition?.nested?.AttributeVisibility && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.DeleteRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.DeleteResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.DeleteResponse?.nested?.DeletedObject && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.CatalogObject && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.InvalidCatalogObject && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.InvalidCatalogObject?.nested?.Reason && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Attribute && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.CogsId && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.Type && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.Range && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.BooleanAttribute && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.SortedAttribute && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.SortedAttribute?.nested?.SortOrder && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.SortedStringIntAttribute && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.SortedStringIntAttribute?.nested?.SortOrder && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.AttributeValues && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.AttributeValues?.nested?.AttributeValue && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.NeighborType && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Query?.nested?.VersionedObjects && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.RstMenusMigrationOptInRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.RstMenusMigrationOptInResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.StockLevel && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.Sort && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.Sort?.nested?.SortField && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.Sort?.nested?.SortOrder && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.SortOrder && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.NullableField && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.ArchivedState && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.MultiFieldTextFilter && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.MultiFieldTextFilter?.nested?.SearchField && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.MultiFieldTextFilter?.nested?.FieldValues && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.SellableValue && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.StockableValue && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogRequest?.nested?.EnabledFulfillmentMethodsFilter && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.EnabledFulfillmentMethod && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.FilterType && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Range && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.CardinalityAggregation && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.CustomAttributeFilter && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SkuCatalogBackfillRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SkuCatalogBackfillResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.UpdateInventoryTrackingRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.UpdateInventoryTrackingResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.VariationTokenList && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.DashboardSearchCatalogResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.MembershipUpdateRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.MembershipUpdateTaxOptions && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.MembershipUpdateResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.SearchCatalogItemsDashboardResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.CatalogItemWrapper && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AdditionalItemData && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AdditionalItemVariationData && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.VariationVendorInfo && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.ReorderObjectRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.ReorderObjectRequest?.nested?.MoveTo && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.BatchReorderObjectsRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.BatchReorderObjectsResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.Feature && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AddMerchantToFeatureRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.AddMerchantToFeatureResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.GenerateSkuValuesInventoryRequest && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.GenerateSkuValuesInventoryResponse && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.MerchantCatalogApiDashboardFe && !$root.nested?.squareup?.nested?.items?.nested?.merchant?.nested?.MerchantCatalogApiDashboardFeBulk) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CatalogObjectType @ squareup/merchant/api.proto at 26:1
 */
export const CatalogObjectType = $root.lookupEnum('squareup.items.merchant.CatalogObjectType').values;
/**
 * SOURCE GetRequest @ squareup/merchant/api.proto at 122:1
 */
export const GetRequest = $root.lookupType('squareup.items.merchant.GetRequest');
fixType(GetRequest);
Builder.createAndAttachToType(GetRequest);
/**
 * SOURCE GetResponse @ squareup/merchant/api.proto at 200:1
 */
export const GetResponse = $root.lookupType('squareup.items.merchant.GetResponse');
fixType(GetResponse);
Builder.createAndAttachToType(GetResponse);
/**
 * PutRequest handles both inserts and updates.
 *
 * If a catalog object has a null token, the service will assume that it is an insert and create a
 * new object with a token.
 *
 * If a catalog object token begins with the temporary token prefix (the # character), a new object
 * will still be given a new token, but all object reference attributes with the object's
 * temporary token in their value will be updated to contain the server generated token. This allows
 * for the atomic creation of a parent object and a child object that references the parent through
 * an attribute. Objects within a request with duplicate temporary tokens will result in an error.
 * Temporary token example: If an object of type Item has the token "#1234" and an object of type
 * Item Variation has an Item Id attribute with the value "#1234", then both the Item's token and
 * the Item Variation's attribute will be updated to the item's new token (perhaps "56789") so that
 * the object reference is maintained, without the real token being generated on the client.
 *
 * If a token is supplied without the prefix, the request will treat it as an update and return an
 * error if the object does not exist.
 * In updating an object, all attributes should be supplied. If an existing attribute is missing,
 * it will be deleted.  If an attribute is supplied with a token, it will be retained / updated.
 * If an attribute is supplied without a token, it will be created.
 *
 * SOURCE PutRequest @ squareup/merchant/api.proto at 287:1
 */
export const PutRequest = $root.lookupType('squareup.items.merchant.PutRequest');
fixType(PutRequest);
Builder.createAndAttachToType(PutRequest);
/**
 * SOURCE CustomAttributePermissionSetting @ squareup/merchant/api.proto at 326:5
 */
PutRequest.CustomAttributePermissionSetting = $root.lookupEnum('squareup.items.merchant.PutRequest.CustomAttributePermissionSetting').values;
/**
 * SOURCE IgnoreItemDefaultsField @ squareup/merchant/api.proto at 335:5
 */
PutRequest.IgnoreItemDefaultsField = $root.lookupEnum('squareup.items.merchant.PutRequest.IgnoreItemDefaultsField').values;
/**
 * SOURCE PutResponse @ squareup/merchant/api.proto at 345:1
 */
export const PutResponse = $root.lookupType('squareup.items.merchant.PutResponse');
fixType(PutResponse);
Builder.createAndAttachToType(PutResponse);
/**
 * SOURCE Status @ squareup/merchant/api.proto at 346:5
 */
PutResponse.Status = $root.lookupEnum('squareup.items.merchant.PutResponse.Status').values;
/**
 * SOURCE AttributeDefinition @ squareup/merchant/api.proto at 371:1
 */
export const AttributeDefinition = $root.lookupType('squareup.items.merchant.AttributeDefinition');
fixType(AttributeDefinition);
Builder.createAndAttachToType(AttributeDefinition);
/**
 * SOURCE Type @ squareup/merchant/api.proto at 380:5
 */
AttributeDefinition.Type = $root.lookupEnum('squareup.items.merchant.AttributeDefinition.Type').values;
/**
 * SOURCE Scope @ squareup/merchant/api.proto at 412:5
 */
AttributeDefinition.Scope = $root.lookupEnum('squareup.items.merchant.AttributeDefinition.Scope').values;
/**
 * SOURCE AttributeClass @ squareup/merchant/api.proto at 423:5
 */
AttributeDefinition.AttributeClass = $root.lookupEnum('squareup.items.merchant.AttributeDefinition.AttributeClass').values;
/**
 * SOURCE AttributeVisibility @ squareup/merchant/api.proto at 432:5
 */
AttributeDefinition.AttributeVisibility = $root.lookupType('squareup.items.merchant.AttributeDefinition.AttributeVisibility');
fixType(AttributeDefinition.AttributeVisibility);
Builder.createAndAttachToType(AttributeDefinition.AttributeVisibility);
/**
 * SOURCE DeleteRequest @ squareup/merchant/api.proto at 441:1
 */
export const DeleteRequest = $root.lookupType('squareup.items.merchant.DeleteRequest');
fixType(DeleteRequest);
Builder.createAndAttachToType(DeleteRequest);
/**
 * SOURCE DeleteResponse @ squareup/merchant/api.proto at 479:1
 */
export const DeleteResponse = $root.lookupType('squareup.items.merchant.DeleteResponse');
fixType(DeleteResponse);
Builder.createAndAttachToType(DeleteResponse);
/**
 * SOURCE DeletedObject @ squareup/merchant/api.proto at 488:5
 */
DeleteResponse.DeletedObject = $root.lookupType('squareup.items.merchant.DeleteResponse.DeletedObject');
fixType(DeleteResponse.DeletedObject);
Builder.createAndAttachToType(DeleteResponse.DeletedObject);
/**
 * SOURCE CatalogObject @ squareup/merchant/api.proto at 545:1
 */
export const CatalogObject = $root.lookupType('squareup.items.merchant.CatalogObject');
fixType(CatalogObject);
Builder.createAndAttachToType(CatalogObject);
/**
 * SOURCE InvalidCatalogObject @ squareup/merchant/api.proto at 563:1
 */
export const InvalidCatalogObject = $root.lookupType('squareup.items.merchant.InvalidCatalogObject');
fixType(InvalidCatalogObject);
Builder.createAndAttachToType(InvalidCatalogObject);
/**
 * SOURCE Reason @ squareup/merchant/api.proto at 564:5
 */
InvalidCatalogObject.Reason = $root.lookupEnum('squareup.items.merchant.InvalidCatalogObject.Reason').values;
/**
 * SOURCE Attribute @ squareup/merchant/api.proto at 933:1
 */
export const Attribute = $root.lookupType('squareup.items.merchant.Attribute');
fixType(Attribute);
Builder.createAndAttachToType(Attribute);
/**
 * CogsId represents an object (item) in the context of a single unit.
 * object_id: unit-level object identifier.
 *   Note: object_id is not guaranteed to be distinct across multiple units.
 * unit_token: unit identifier for context.
 *
 * SOURCE CogsId @ squareup/merchant/api.proto at 948:1
 */
export const CogsId = $root.lookupType('squareup.items.merchant.CogsId');
fixType(CogsId);
Builder.createAndAttachToType(CogsId);
/**
 * SOURCE Query @ squareup/merchant/api.proto at 953:1
 */
export const Query = $root.lookupType('squareup.items.merchant.Query');
fixType(Query);
Builder.createAndAttachToType(Query);
/**
 * Type of search to perform.
 *
 * SOURCE Type @ squareup/merchant/api.proto at 957:5
 */
Query.Type = $root.lookupEnum('squareup.items.merchant.Query.Type').values;
/**
 * SOURCE Range @ squareup/merchant/api.proto at 1055:5
 */
Query.Range = $root.lookupType('squareup.items.merchant.Query.Range');
fixType(Query.Range);
Builder.createAndAttachToType(Query.Range);
/**
 * SOURCE BooleanAttribute @ squareup/merchant/api.proto at 1060:5
 */
Query.BooleanAttribute = $root.lookupType('squareup.items.merchant.Query.BooleanAttribute');
fixType(Query.BooleanAttribute);
Builder.createAndAttachToType(Query.BooleanAttribute);
/**
 * SOURCE SortedAttribute @ squareup/merchant/api.proto at 1064:5
 */
Query.SortedAttribute = $root.lookupType('squareup.items.merchant.Query.SortedAttribute');
fixType(Query.SortedAttribute);
Builder.createAndAttachToType(Query.SortedAttribute);
/**
 * SOURCE SortOrder @ squareup/merchant/api.proto at 1067:9
 */
Query.SortedAttribute.SortOrder = $root.lookupEnum('squareup.items.merchant.Query.SortedAttribute.SortOrder').values;
/**
 * SOURCE SortedStringIntAttribute @ squareup/merchant/api.proto at 1076:5
 */
Query.SortedStringIntAttribute = $root.lookupType('squareup.items.merchant.Query.SortedStringIntAttribute');
fixType(Query.SortedStringIntAttribute);
Builder.createAndAttachToType(Query.SortedStringIntAttribute);
/**
 * SOURCE SortOrder @ squareup/merchant/api.proto at 1079:9
 */
Query.SortedStringIntAttribute.SortOrder = $root.lookupEnum('squareup.items.merchant.Query.SortedStringIntAttribute.SortOrder').values;
/**
 * SOURCE AttributeValues @ squareup/merchant/api.proto at 1089:5
 */
Query.AttributeValues = $root.lookupType('squareup.items.merchant.Query.AttributeValues');
fixType(Query.AttributeValues);
Builder.createAndAttachToType(Query.AttributeValues);
/**
 * Filter specifying objects that have a given value for any one of a set of attribute definition tokens.
 *
 * SOURCE AttributeValue @ squareup/merchant/api.proto at 1092:9
 */
Query.AttributeValues.AttributeValue = $root.lookupType('squareup.items.merchant.Query.AttributeValues.AttributeValue');
fixType(Query.AttributeValues.AttributeValue);
Builder.createAndAttachToType(Query.AttributeValues.AttributeValue);
/**
 * Defines a set of graph edge types to include in the output of a neighbor query. The edge type is defined by the
 * object type that anchors it, and the set of attribute types that hold the token of the edge's destination object.
 *
 * SOURCE NeighborType @ squareup/merchant/api.proto at 1132:5
 */
Query.NeighborType = $root.lookupType('squareup.items.merchant.Query.NeighborType');
fixType(Query.NeighborType);
Builder.createAndAttachToType(Query.NeighborType);
/**
 * Retrieve a batch of objects at a particular version. The GetResponse will contain the versioned objects
 * in the order that they were requested. This query type may not be combined with other queries.
 * The following fields of GetRequest are disallowed when a `VERSIONED_OBJECTS` query is included:
 *
 * type, limit, paginationToken, modified_after, version, enabled_unit_tokens, lock_token,
 * initial_version_fallback, perform_sync.
 *
 * SOURCE VersionedObjects @ squareup/merchant/api.proto at 1188:5
 */
Query.VersionedObjects = $root.lookupType('squareup.items.merchant.Query.VersionedObjects');
fixType(Query.VersionedObjects);
Builder.createAndAttachToType(Query.VersionedObjects);
/**
 * SOURCE RstMenusMigrationOptInRequest @ squareup/merchant/api.proto at 1262:1
 */
export const RstMenusMigrationOptInRequest = $root.lookupType('squareup.items.merchant.RstMenusMigrationOptInRequest');
fixType(RstMenusMigrationOptInRequest);
Builder.createAndAttachToType(RstMenusMigrationOptInRequest);
/**
 * SOURCE RstMenusMigrationOptInResponse @ squareup/merchant/api.proto at 1264:1
 */
export const RstMenusMigrationOptInResponse = $root.lookupType('squareup.items.merchant.RstMenusMigrationOptInResponse');
fixType(RstMenusMigrationOptInResponse);
Builder.createAndAttachToType(RstMenusMigrationOptInResponse);
/**
 * SOURCE StockLevel @ squareup/merchant/api.proto at 1334:1
 */
export const StockLevel = $root.lookupEnum('squareup.items.merchant.StockLevel').values;
/**
 * SOURCE SearchCatalogRequest @ squareup/merchant/api.proto at 1346:1
 */
export const SearchCatalogRequest = $root.lookupType('squareup.items.merchant.SearchCatalogRequest');
fixType(SearchCatalogRequest);
Builder.createAndAttachToType(SearchCatalogRequest);
/**
 * SOURCE Sort @ squareup/merchant/api.proto at 1347:5
 */
SearchCatalogRequest.Sort = $root.lookupType('squareup.items.merchant.SearchCatalogRequest.Sort');
fixType(SearchCatalogRequest.Sort);
Builder.createAndAttachToType(SearchCatalogRequest.Sort);
/**
 * SOURCE SortField @ squareup/merchant/api.proto at 1348:9
 */
SearchCatalogRequest.Sort.SortField = $root.lookupEnum('squareup.items.merchant.SearchCatalogRequest.Sort.SortField').values;
/**
 * SOURCE SortOrder @ squareup/merchant/api.proto at 1355:9
 */
SearchCatalogRequest.Sort.SortOrder = $root.lookupEnum('squareup.items.merchant.SearchCatalogRequest.Sort.SortOrder').values;
/**
 * SOURCE SortOrder @ squareup/merchant/api.proto at 1368:5
 */
SearchCatalogRequest.SortOrder = $root.lookupEnum('squareup.items.merchant.SearchCatalogRequest.SortOrder').values;
/**
 * SOURCE NullableField @ squareup/merchant/api.proto at 1372:5
 */
SearchCatalogRequest.NullableField = $root.lookupEnum('squareup.items.merchant.SearchCatalogRequest.NullableField').values;
/**
 * SOURCE ArchivedState @ squareup/merchant/api.proto at 1379:5
 */
SearchCatalogRequest.ArchivedState = $root.lookupEnum('squareup.items.merchant.SearchCatalogRequest.ArchivedState').values;
/**
 * SOURCE MultiFieldTextFilter @ squareup/merchant/api.proto at 1385:5
 */
SearchCatalogRequest.MultiFieldTextFilter = $root.lookupType('squareup.items.merchant.SearchCatalogRequest.MultiFieldTextFilter');
fixType(SearchCatalogRequest.MultiFieldTextFilter);
Builder.createAndAttachToType(SearchCatalogRequest.MultiFieldTextFilter);
/**
 * SOURCE SearchField @ squareup/merchant/api.proto at 1386:9
 */
SearchCatalogRequest.MultiFieldTextFilter.SearchField = $root.lookupEnum('squareup.items.merchant.SearchCatalogRequest.MultiFieldTextFilter.SearchField').values;
/**
 * SOURCE FieldValues @ squareup/merchant/api.proto at 1402:9
 */
SearchCatalogRequest.MultiFieldTextFilter.FieldValues = $root.lookupType('squareup.items.merchant.SearchCatalogRequest.MultiFieldTextFilter.FieldValues');
fixType(SearchCatalogRequest.MultiFieldTextFilter.FieldValues);
Builder.createAndAttachToType(SearchCatalogRequest.MultiFieldTextFilter.FieldValues);
/**
 * SOURCE SellableValue @ squareup/merchant/api.proto at 1413:5
 */
SearchCatalogRequest.SellableValue = $root.lookupEnum('squareup.items.merchant.SearchCatalogRequest.SellableValue').values;
/**
 * SOURCE StockableValue @ squareup/merchant/api.proto at 1418:5
 */
SearchCatalogRequest.StockableValue = $root.lookupEnum('squareup.items.merchant.SearchCatalogRequest.StockableValue').values;
/**
 * SOURCE EnabledFulfillmentMethodsFilter @ squareup/merchant/api.proto at 1507:5
 */
SearchCatalogRequest.EnabledFulfillmentMethodsFilter = $root.lookupType('squareup.items.merchant.SearchCatalogRequest.EnabledFulfillmentMethodsFilter');
fixType(SearchCatalogRequest.EnabledFulfillmentMethodsFilter);
Builder.createAndAttachToType(SearchCatalogRequest.EnabledFulfillmentMethodsFilter);
/**
 * SOURCE EnabledFulfillmentMethod @ squareup/merchant/api.proto at 1516:1
 */
export const EnabledFulfillmentMethod = $root.lookupEnum('squareup.items.merchant.EnabledFulfillmentMethod').values;
/**
 * SOURCE FilterType @ squareup/merchant/api.proto at 1524:1
 */
export const FilterType = $root.lookupEnum('squareup.items.merchant.FilterType').values;
/**
 * SOURCE Range @ squareup/merchant/api.proto at 1530:1
 */
export const Range = $root.lookupType('squareup.items.merchant.Range');
fixType(Range);
Builder.createAndAttachToType(Range);
/**
 * SOURCE CardinalityAggregation @ squareup/merchant/api.proto at 1535:1
 */
export const CardinalityAggregation = $root.lookupType('squareup.items.merchant.CardinalityAggregation');
fixType(CardinalityAggregation);
Builder.createAndAttachToType(CardinalityAggregation);
/**
 * SOURCE CustomAttributeFilter @ squareup/merchant/api.proto at 1540:1
 */
export const CustomAttributeFilter = $root.lookupType('squareup.items.merchant.CustomAttributeFilter');
fixType(CustomAttributeFilter);
Builder.createAndAttachToType(CustomAttributeFilter);
/**
 * SOURCE SkuCatalogBackfillRequest @ squareup/merchant/api.proto at 1595:1
 */
export const SkuCatalogBackfillRequest = $root.lookupType('squareup.items.merchant.SkuCatalogBackfillRequest');
fixType(SkuCatalogBackfillRequest);
Builder.createAndAttachToType(SkuCatalogBackfillRequest);
/**
 * SOURCE SkuCatalogBackfillResponse @ squareup/merchant/api.proto at 1600:1
 */
export const SkuCatalogBackfillResponse = $root.lookupType('squareup.items.merchant.SkuCatalogBackfillResponse');
fixType(SkuCatalogBackfillResponse);
Builder.createAndAttachToType(SkuCatalogBackfillResponse);
/**
 * SOURCE UpdateInventoryTrackingRequest @ squareup/merchant/api.proto at 1615:1
 */
export const UpdateInventoryTrackingRequest = $root.lookupType('squareup.items.merchant.UpdateInventoryTrackingRequest');
fixType(UpdateInventoryTrackingRequest);
Builder.createAndAttachToType(UpdateInventoryTrackingRequest);
/**
 * SOURCE UpdateInventoryTrackingResponse @ squareup/merchant/api.proto at 1618:1
 */
export const UpdateInventoryTrackingResponse = $root.lookupType('squareup.items.merchant.UpdateInventoryTrackingResponse');
fixType(UpdateInventoryTrackingResponse);
Builder.createAndAttachToType(UpdateInventoryTrackingResponse);
/**
 * wrapper message for matched_variation map
 *
 * SOURCE VariationTokenList @ squareup/merchant/api.proto at 1624:1
 */
export const VariationTokenList = $root.lookupType('squareup.items.merchant.VariationTokenList');
fixType(VariationTokenList);
Builder.createAndAttachToType(VariationTokenList);
/**
 * DashboardSearchCatalogResponse has a matched_variation map specific to dashboard
 *
 * SOURCE DashboardSearchCatalogResponse @ squareup/merchant/api.proto at 1629:1
 */
export const DashboardSearchCatalogResponse = $root.lookupType('squareup.items.merchant.DashboardSearchCatalogResponse');
fixType(DashboardSearchCatalogResponse);
Builder.createAndAttachToType(DashboardSearchCatalogResponse);
/**
 * SOURCE MembershipUpdateRequest @ squareup/merchant/api.proto at 1985:1
 */
export const MembershipUpdateRequest = $root.lookupType('squareup.items.merchant.MembershipUpdateRequest');
fixType(MembershipUpdateRequest);
Builder.createAndAttachToType(MembershipUpdateRequest);
/**
 * SOURCE MembershipUpdateTaxOptions @ squareup/merchant/api.proto at 2007:1
 */
export const MembershipUpdateTaxOptions = $root.lookupType('squareup.items.merchant.MembershipUpdateTaxOptions');
fixType(MembershipUpdateTaxOptions);
Builder.createAndAttachToType(MembershipUpdateTaxOptions);
/**
 * SOURCE MembershipUpdateResponse @ squareup/merchant/api.proto at 2013:1
 */
export const MembershipUpdateResponse = $root.lookupType('squareup.items.merchant.MembershipUpdateResponse');
fixType(MembershipUpdateResponse);
Builder.createAndAttachToType(MembershipUpdateResponse);
/**
 * This response is the same as the response from the Connect SearchCatalogItems endpoint
 * except that each item is in a wrapper object with extra data needed by Dashboard.
 *
 * SOURCE SearchCatalogItemsDashboardResponse @ squareup/merchant/api.proto at 2021:1
 */
export const SearchCatalogItemsDashboardResponse = $root.lookupType('squareup.items.merchant.SearchCatalogItemsDashboardResponse');
fixType(SearchCatalogItemsDashboardResponse);
Builder.createAndAttachToType(SearchCatalogItemsDashboardResponse);
/**
 * This message contains additional data that DashboardFe will populate
 * for each item to reduce the number of network round trips when loading the item library.
 *
 * SOURCE CatalogItemWrapper @ squareup/merchant/api.proto at 2029:1
 */
export const CatalogItemWrapper = $root.lookupType('squareup.items.merchant.CatalogItemWrapper');
fixType(CatalogItemWrapper);
Builder.createAndAttachToType(CatalogItemWrapper);
/**
 * Additional data that is not immediately available on the ConnectV2 item proto
 * that is needed by Dashboard for displaying the item library. This message can be extended
 * in the future if the needs of the Item Library page change.
 *
 * SOURCE AdditionalItemData @ squareup/merchant/api.proto at 2039:1
 */
export const AdditionalItemData = $root.lookupType('squareup.items.merchant.AdditionalItemData');
fixType(AdditionalItemData);
Builder.createAndAttachToType(AdditionalItemData);
/**
 * Additional data that is not immediately available on the ConnectV2 item variation proto
 * that is needed by Dashboard for displaying the item library. This message can be extended
 * in the future if the needs of the Item Library page change.
 *
 * SOURCE AdditionalItemVariationData @ squareup/merchant/api.proto at 2047:1
 */
export const AdditionalItemVariationData = $root.lookupType('squareup.items.merchant.AdditionalItemVariationData');
fixType(AdditionalItemVariationData);
Builder.createAndAttachToType(AdditionalItemVariationData);
/**
 * Contains the attributes of a ItemVariationVendorInfo object linked to a variation.
 * There is currently no ConnectV2 proto for representing this data because costs and vendors
 * have not been exposed in our APIs. This will likely change in the future at which point we
 * can remove this proto.
 *
 * SOURCE VariationVendorInfo @ squareup/merchant/api.proto at 2060:1
 */
export const VariationVendorInfo = $root.lookupType('squareup.items.merchant.VariationVendorInfo');
fixType(VariationVendorInfo);
Builder.createAndAttachToType(VariationVendorInfo);
/**
 * A request to reorder an object by its ordinal with respect to its parent object.
 *
 * SOURCE ReorderObjectRequest @ squareup/merchant/api.proto at 2068:1
 */
export const ReorderObjectRequest = $root.lookupType('squareup.items.merchant.ReorderObjectRequest');
fixType(ReorderObjectRequest);
Builder.createAndAttachToType(ReorderObjectRequest);
/**
 * SOURCE MoveTo @ squareup/merchant/api.proto at 2078:5
 */
ReorderObjectRequest.MoveTo = $root.lookupEnum('squareup.items.merchant.ReorderObjectRequest.MoveTo').values;
/**
 * A batch request to reorder objects by their ordinal with respect to their parent object. The order of the requests
 * matters as it will affect to resulting ordering.
 *
 * SOURCE BatchReorderObjectsRequest @ squareup/merchant/api.proto at 2091:1
 */
export const BatchReorderObjectsRequest = $root.lookupType('squareup.items.merchant.BatchReorderObjectsRequest');
fixType(BatchReorderObjectsRequest);
Builder.createAndAttachToType(BatchReorderObjectsRequest);
/**
 * SOURCE BatchReorderObjectsResponse @ squareup/merchant/api.proto at 2117:1
 */
export const BatchReorderObjectsResponse = $root.lookupType('squareup.items.merchant.BatchReorderObjectsResponse');
fixType(BatchReorderObjectsResponse);
Builder.createAndAttachToType(BatchReorderObjectsResponse);
/**
 * SOURCE Feature @ squareup/merchant/api.proto at 2122:1
 */
export const Feature = $root.lookupEnum('squareup.items.merchant.Feature').values;
/**
 * A request to add a merchant to a a feature which maps to a Launch Darkly segment that feature flags may read from.
 *
 * SOURCE AddMerchantToFeatureRequest @ squareup/merchant/api.proto at 2128:1
 */
export const AddMerchantToFeatureRequest = $root.lookupType('squareup.items.merchant.AddMerchantToFeatureRequest');
fixType(AddMerchantToFeatureRequest);
Builder.createAndAttachToType(AddMerchantToFeatureRequest);
/**
 * SOURCE AddMerchantToFeatureResponse @ squareup/merchant/api.proto at 2133:1
 */
export const AddMerchantToFeatureResponse = $root.lookupType('squareup.items.merchant.AddMerchantToFeatureResponse');
fixType(AddMerchantToFeatureResponse);
Builder.createAndAttachToType(AddMerchantToFeatureResponse);
/**
 * SOURCE GenerateSkuValuesInventoryRequest @ squareup/merchant/api.proto at 2136:1
 */
export const GenerateSkuValuesInventoryRequest = $root.lookupType('squareup.items.merchant.GenerateSkuValuesInventoryRequest');
fixType(GenerateSkuValuesInventoryRequest, {
  count: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GenerateSkuValuesInventoryRequest);
/**
 * SOURCE GenerateSkuValuesInventoryResponse @ squareup/merchant/api.proto at 2141:1
 */
export const GenerateSkuValuesInventoryResponse = $root.lookupType('squareup.items.merchant.GenerateSkuValuesInventoryResponse');
fixType(GenerateSkuValuesInventoryResponse);
Builder.createAndAttachToType(GenerateSkuValuesInventoryResponse);
/**
 * MerchantCatalogApiDashboardFe contains a subset of the MerchantCatalogAPI endpoints.
 * There are extra attributes that are inserted to pass along inventory data on the item variations.
 *
 * SOURCE MerchantCatalogApiDashboardFe @ squareup/merchant/api.proto at 2148:1
 */
export const MerchantCatalogApiDashboardFe = $root.lookupService('squareup.items.merchant.MerchantCatalogApiDashboardFe');
/**
 * SOURCE MerchantCatalogApiDashboardFeBulk @ squareup/merchant/api.proto at 2216:1
 */
export const MerchantCatalogApiDashboardFeBulk = $root.lookupService('squareup.items.merchant.MerchantCatalogApiDashboardFeBulk');